import * as ko from "knockout";

import * as $ from "../jquery";

import { addBindingHandler } from "./util";


/**
 * Binding to set the text on a Pli button.
 */
export interface PliButtonTextBinding {
    update: (element: HTMLElement, valueAccessor: () => ko.MaybeSubscribable<any>) => void;
}


/**
 * Returns true if the element assigned to "this" is a Text node (node type = 3).
 *
 * TODO Uncomment "this"" typing for TypeScript 2.0.
 */
function isTextNode(/* this: HTMLElement*/): boolean {
    return this.nodeType === 3;
}


const pliButtonTextBinding: PliButtonTextBinding = {
    update: (element, valueAccessor) => {
        const text = ko.unwrap(valueAccessor()) || "-";
        // set title without removing child elements (span with icon); see http://stackoverflow.com/questions/4106809/in-jquery-how-can-i-change-an-elements-text-without-changing-its-child-elements/4106957#4106957
        $(element)
            .find("span")
            .contents() // enumerate children
            .filter(isTextNode)
            .eq(0) // first text node
            .replaceWith(text);
    }
};


/**
 * Activates the 'pliButtonText' binding.
 */
export function activatePliButtonTextBinding(): PliButtonTextBinding {
    return addBindingHandler("pliButtonText", pliButtonTextBinding);
}



// WEBPACK FOOTER //
// /Users/johng/dev/web-pli/knockout/pliButtonText.ts